module.exports = __webpack_public_path__ + "static/media/16UNODC34.f690c4c1.jpg";